import { FormValidationRule } from "../types";

const PDFLinkTrackerRule: FormValidationRule = (c, v) => {
    let valid = true;
    if (c.type === "pdfLinkTracker" && v && c.inputs) {
        const value = v[c.inputs[0].id];
        if (value !== "clicked" && value !== "not clicked") {
            valid = false;
        }else if(value === "not clicked" && c.isRequired){
            valid = false
        }
    }

    return [valid, c.errorMessage || "You must open this document in order to progress"];
};

export default PDFLinkTrackerRule;
